<div class="main-content">
  <div class="main-header">
    <a [routerLink]="['/config-workbook/workbookcsv']" style="cursor: pointer;"><img
        src="./assets/Expand-Column-left.svg" alt="Image 1" class="r-m20" style="vertical-align: middle;" /></a>
    Config Workbook <div class="tooltip"><img src="./assets/Info.svg" alt="Image 1" /><span class="tooltiptext">Convert
        Workbook To CSV Extract.</span></div>
  </div>



  <div class="section">

    <div class="content" style="margin: 10px 16px">
      <p class="text_16_b" style="display: inline-block;margin-top: 10px;">Convert Workbook to CSV Extract </p>
    </div>
    <div class="content" style="margin: 0px 16px;padding-bottom: 21px; border-bottom: 2px solid rgba(5, 5, 5, 0.12);">
      <div style="display: inline-block; border-right: 1px solid #c4c4c4; padding-right: 20px;">
        <p class="text_12">New Batch Key</p>
        <p class="text_14">{{batchKey}}</p>
      </div>
      <div *ngIf="batchKey"
        style="display: inline-block; border-right: 1px solid #c4c4c4; margin-left: 20px; padding-right: 20px;min-width: 100px;">
        <p class="text_12">Status</p>
        <p *ngIf="batchKey" class="text_14">{{batchStatus}} </p>
      </div>
      <div *ngIf="batchKey" style="display: inline-block; margin-left: 20px;">
        <p class="text_12">Date </p>
        <p *ngIf="batchKey" class="text_14">{{startDate1 | date: 'dd/MM/yyyy'}} </p>
      </div>
      <div style="float: right;">
        <button mat-flat-button [disabled]="submitNewBtnDisable" class="green-button"
          style="float: right;margin-left: 40px;margin-top: 10px;min-width: 120px;"
          (click)="onWorkbookReverseFlowSubmit()"> Generate Extract </button>
      </div>
    </div>


    <div class="content" style="margin: 0px 16px 32px 16px;">
      <div *ngFor="let item of tracks; let i = index" class="tracks-class">
        <span (click)="showArray[i]=!showArray[i]"><span *ngIf="!showArray[i]"><img src="./assets/Expand-Column.svg"
              class="expand-button" alt="Expand_Column"></span>
          <span *ngIf="showArray[i]"><img src="./assets/Expand-Column-svg.svg"
              class="expand-button" alt="Expand_Column"></span><button mat-button>{{item}}</button>
        </span>
        <div *ngIf="showArray[i]">
          <mat-radio-group [(ngModel)]="moduleName">
            <div *ngFor="let configItem of configData; let i= index">
              <ng-container class="b-spacing container" *ngIf="item === configItem.TRACK">
                <div class="item" style="width:50%; float:left">
                  <mat-checkbox (click)="configPopUp(configItem,i)" [checked]="configItem.saveStatus"
                    [disableRipple]="true" (click)="$event.preventDefault()" class="example-radio-button"
                    (change)="onChange($event,configItem.APPLICATION,item)" [value]="configItem.APPLICATION"
                    type="Checkbox">{{configItem.APPLICATION}}
                  </mat-checkbox>

                  <div>
                    <div *ngIf="showArray1[i]">
                      <div class="gray-bg">
                        <p class="font-w-b">Workbook</p>
                        <div>Upload Workbook file <div class="tooltip"><img src="./assets/Info.svg" alt="Image 1"
                              class="tool-info" /><span class="tooltiptext1">Supported file format: .xlsx</span></div>
                        </div>
                        <input #fileInput (click)="onFileInputClicked(fileInput, configItem)" type="file"
                          name="fileData" (change)="onFileSelectedForCsvExtract($event,configItem.APPLICATION)"
                          class="form-control1 upload-icon" />
                      </div>


                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </mat-radio-group>
        </div>
      </div>
    </div>

  </div>
</div>
